<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'">
    <v-card-text class="trade">
      <div class="icon-wrapper-body">
        <div class="icon-wrapper">
          <div class="icon-box">
            <!-- keep your same svg -->
            <slot name="icon">
              <!-- paste your Business Amount svg here (same as old file) -->
            </slot>
          </div>

          <div class="icon-content">
            <h3>Business Amount</h3>
            <span>Total</span>
          </div>
        </div>

        <div class="iconClass icon-badge">
          <v-icon>mdi mdi-arrow-up</v-icon>
        </div>
      </div>

      <p class="amount">
        <span v-if="businessAmount">
          $<countTo :startVal="startVal" :endVal="parseAmount(businessAmount)" :duration="3000" />
        </span>
        <span v-else>$ 0</span>

        <router-link class="links" to="./live-trades">Details</router-link>
      </p>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { PROFILE__ACTIONS } from "@/store/action-types";
import countTo from "vue-count-to";
import { parseAmount } from "./utils";

export default {
  components: { countTo },
  data: () => ({ startVal: 0 }),
  computed: {
    ...mapState("profile", ["businessAmount"]),
  },
  methods: {
    ...mapActions("profile", [PROFILE__ACTIONS.BUSINESSAMOUNT]),
    parseAmount,
  },
  async created() {
    // If DashboardView will already call API once, we can skip it here.
    // But if you want each card self loading, keep this:
    await this[PROFILE__ACTIONS.BUSINESSAMOUNT]();
  },
};
</script>
